// src/services/AsistenciaService.js
import fetch from 'auth/FetchInterceptor';

const AsistenciaService = {};

AsistenciaService.getAll = function (params = {}) {
    return fetch({
        url: '/v1/asistencias',
        method: 'get',
        params,
    });
};

AsistenciaService.getById = function (id) {
    return fetch({
        url: `/v1/asistencias/${id}`,
        method: 'get',
    });
};

// Registro manual desde el panel (origen `manual`). El alta genérica
// POST /asistencias es la ruta de integración y no la usa el panel.
AsistenciaService.createManual = function (data) {
    return fetch({
        url: '/v1/asistencias/manual',
        method: 'post',
        data,
    });
};

AsistenciaService.update = function (id, data) {
    return fetch({
        url: `/v1/asistencias/${id}`,
        method: 'put',
        data,
    });
};

AsistenciaService.remove = function (id) {
    return fetch({
        url: `/v1/asistencias/${id}`,
        method: 'delete',
    });
};

export default AsistenciaService;
